"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionIndex = exports.fetchRelatedSection = exports.fetchRelated = void 0;
var ajax_1 = require("../ajax");
var fetchRelated = function (product_id, limit) {
    if (limit === void 0) { limit = 4; }
    return ((0, ajax_1.ajaxRequest)("/recommendations/products.json", 'GET', { product_id: product_id, limit: limit }));
};
exports.fetchRelated = fetchRelated;
var fetchRelatedSection = function (params) {
    return (0, ajax_1.ajaxRequest)(params.product_recommendations_url, 'GET', params);
};
exports.fetchRelatedSection = fetchRelatedSection;
var getOptionIndex = function (params) { return (params.product.options_with_values.findIndex(function (o) { return (params.options.some(function (po) { return po.toLowerCase() == o.name.toLowerCase(); })); })); };
exports.getOptionIndex = getOptionIndex;
//# sourceMappingURL=index.js.map